module.exports = __webpack_public_path__ + "img/IMG_8512_P_L_BlackMatted.9f7a860f.jpg";